import { render, staticRenderFns } from "./ElementStudioSpacingBar.vue?vue&type=template&id=33cfa7e7&"
import script from "./ElementStudioSpacingBar.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioSpacingBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports